import * as React from 'react'
import { useEffect, useState, useRef, useLayoutEffect } from 'react'
import { withRouter } from 'react-router-dom'
import globalBus from '@/services/Bus'
import { useGlobalBus } from '@/services/global-bus'
import { isPC } from '@/utils/tools'
import { reportClickEvent } from '@weike/operation-report'
import { RegisterElement } from '@/services/hotspotReport'
import style from './index.module.less'

let SCROLLTOP_FIXED_VARIABLE = 42
function HomeCategory(props) {
  const [isScrollToHeader, setIsScrollToHeader] = useState<boolean>()
  const [selectIndex, setSelectIndex] = useState<number | string>('')
  const HomeCategoryRef = useRef<HTMLDivElement>()
  const [offsetWidth, setOffsetWidth] = useState<number>(0)
  const { content } = props
  const isInIndex = !/category/.test(window.location.pathname) ? true : false
  const isShowMoveTrack = window.sessionStorage.getItem('isVisitOneTime') && window.sessionStorage.getItem('isVisitOneTime') === 'true' ? true : false

  useGlobalBus({
    categoryActiveId: info => {
      if (window.location.pathname.indexOf('category') > -1) {
        SCROLLTOP_FIXED_VARIABLE = 42
      }
      setSelectIndex(info)
    },

    isShowTopCouponTips: info => {
      if (info === 'true') {
        SCROLLTOP_FIXED_VARIABLE = 82
      } else {
        SCROLLTOP_FIXED_VARIABLE = 42
      }
    }
  })

  useLayoutEffect(() => {
    if (content.length > 0) {
      calculatorWidth(content)
      scrollToTarget(content)
    }
  })

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  })

  const scrollToTarget = details => {
    if (selectIndex) {
      const index = details.findIndex(item => {
        return item.id === selectIndex
      })
      handleScrollIndex(index)
    }
  }

  const calculatorWidth = details => {
    let len = 0
    let offset = 0
    const clientWidth = Math.min(480, document.body.clientWidth)
    details.map(item => {
      len += item.name.length * 14 + 30
    })
    offset = len - clientWidth + 60
    setOffsetWidth(offset)
    if (isInIndex && !isShowMoveTrack) {
      setTimeout(() => {
        // (document as any).querySelector('#HomeCategoryMenu').style.cssText = ""
        const HomeCategoryMenu = (document as any).querySelector('#HomeCategoryMenu')
        if (HomeCategoryMenu) {
          HomeCategoryMenu.style.cssText = ''
        }
        window.sessionStorage.setItem('isVisitOneTime', 'true')
      }, 1500)
    }
  }

  const handleScroll = () => {
    if (HomeCategoryRef.current && HomeCategoryRef.current !== null) {
      if (document.body.scrollTop + document.documentElement.scrollTop >= SCROLLTOP_FIXED_VARIABLE) {
        if (!isScrollToHeader) {
          setIsScrollToHeader(true)
        }
      } else {
        if (isScrollToHeader) {
          setIsScrollToHeader(false)
        }
      }
    }
  }

  const handleScrollIndex = index => {
    const getLastSelectIndex = Number(window.sessionStorage.getItem('HOMEPAGE/CATEGORY_SELECT/INDEX') || 0)
    if (getLastSelectIndex >= 1) {
      HomeCategoryRef.current.scrollLeft = (getLastSelectIndex - 1) * 80
    }
  }

  const linkto = (id: number, index: number, categoryName: string) => {
    if (selectIndex === id) {
      return
    }
    window.sessionStorage.setItem('HOMEPAGE/CATEGORY_SELECT/INDEX', index.toString())
    window.sessionStorage.setItem('HOMEPAGE/CATEGORY_SELECT/CATEGORYNAME', categoryName)
    if (id === 0) {
      props.history.replace(`/`)
    } else {
      props.history.replace(`/category?id=${id}&recommend=true`)
      globalBus.emit({ changeRecommendCategoryId: id })
      globalBus.emit({ categoryActiveId: id })
    }
    reportClickEvent(RegisterElement.category_bar, { object_id: id, object_type: categoryName })
  }

  return (
    <div style={{height: 48}} className={[style.HomeCategoryContainer, (isScrollToHeader ? style.fixedHomeCategory : ''), (isInIndex ? style.addBoxShadow : '')].join(' ')}>
      <a className={style.HomeCategoryFixedItem}>
        <div
          className={[style.HomeCategoryItemText, (selectIndex === 0 ? style.seletctActive : '')].join(' ')}
          onClick={() => {
            linkto(0, 0, '推荐')
          }}
        >
          推荐
        </div>
      </a>
      <div id="HomeCategoryMenuRoot" ref={HomeCategoryRef} className={[style.HomeCategoryWrap, (isPC() ? style.HomeCategoryWrapIfPc : null)].join(' ')}>
        <div
          id="HomeCategoryMenu"
          className={[style.HomeCategory, style.offsetWidthMove].join(' ')}
          style={{ transform: isInIndex && !isShowMoveTrack && `translate(-${offsetWidth}px)` }}
        >
          {content.map((v, index) => (
            <div key={v.id} style={{display: 'table'}} id={`categoryItem-${v.id}`} className={style.HomeCategoryItem} onClick={() => linkto(v.id, index, v.name)}>
              <div className={[style.HomeCategoryItemText, (selectIndex === v.id ? style.seletctActive : '')].join(' ')}>{v.name}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default withRouter(HomeCategory)



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeCategory/HomeCategory.tsx